import React, { Fragment } from 'react';
import type { FC } from 'react';

import { useAnnotations } from '@confluence/annotation-provider-store';

import { CreateComponent } from './CreateComponent';
import { ViewComponent } from './ViewComponent';

export const EditorAnnotationProviderComponents: FC = () => {
	const { editorCreateProps, editorViewProps } = useAnnotations();

	return (
		<Fragment>
			{editorCreateProps && <CreateComponent {...editorCreateProps} />}
			{editorViewProps && <ViewComponent {...editorViewProps} />}
		</Fragment>
	);
};
